import useHierarquiaMapaCalor from './useHierarquiaMapaCalor';

export default function useDashboardMapaCalorLikert(entidadeId, options) {
  return useHierarquiaMapaCalor(entidadeId, {
    ...options,
    endpoint: '/FormularioGlobalDashboard/ObterMapaCalorLikert',
  });
}
